import { Main, Count, Title, Topline, Icon } from './styles';
import SVGIcon from '../../../../assets/images/svg/SVGIcon';
import Tooltip from '../../../../component/tooltip';
import { ICON_SIZE } from '../../../../global/constants';

interface Props {
  title: string;
  members?: number;
  totalMembers?: number;
  count: string | number;
  isTeamMember?: boolean;
}
export default function UsageBox(props: Props) {
  const { members, totalMembers, title, count, isTeamMember } = props || {};

  return (
    <>
      <Main isTeamMember={isTeamMember}>
        {isTeamMember ? (
          <Topline>
            <Title>{title}</Title>
            <Tooltip
              title={`${members} out of ${totalMembers} users license utilised from your active subscription.`}
              placement='bottomRight'
              maxWidth={'167px'}>
              <Icon>
                <SVGIcon
                  name='storage-info-icon'
                  width={ICON_SIZE.MD}
                  height={ICON_SIZE.MD}
                  viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  fill='var(--text-secondary)'
                />
              </Icon>
            </Tooltip>
          </Topline>
        ) : (
          <Title>{title}</Title>
        )}
        <Count>{count}</Count>
      </Main>
    </>
  );
}
